// Copyright (c) Move Closer 2022.

import { HasStructure, IRelatedService, ModuleContentResolver, ModulesUiRegistryEntry } from '../contexts'

import { AvailableModuleDriver } from './allowed'
import { ContainerUi, resolveContainerContent } from './Container/ui'

import { accordionModule } from './Accordion/ui'
import { advertiseBoxModule } from './AdvertiseBox/ui'
import { articlesListModule } from './ArticlesList/ui'
import { articleHeaderModule } from './ArticleHeader/ui'
import { articlesTeaserModule } from './ArticlesTeaser/ui'
import { articleTeaserBoxModule } from './ArticlesTeaserBox/ui'
import { artisticCarouselModule } from './ArtisticCarousel/ui'
import { attachmentsListModule } from './AttachmentsList/ui'
import { brandTeaserModule } from './BrandTeaser/ui'
import { buttonModule } from './Button/ui'
import { benefitsBoxModule } from './BenefitsBox/ui'
import { breadcrumbsModule } from './Breadcrumbs/ui'
import { certificatesListModule } from './CertificatesList/ui'
import { ctaModule } from './CTABox/ui'
import { contactFormModule } from './ContactForm/ui'
import { creationsModule } from './Creations/ui'
import { customerSupportModule } from './CustomerSuport/ui'
import { descriptionListModule } from './DescriptionList/ui'
import { floatingOrderRenewalModule } from './FloatingOrderRenewal/ui'
import { footerModule } from './Footer/ui'
import { headingModule } from './Heading/ui'
import { heroModule } from './Hero/ui'
import { imageModule } from './Image/ui'
import { imageListModule } from './ImageList/ui'
import { navbarModule } from './Navbar/ui'
import { navigationCTABoxModule } from './NavigationCTABox/ui'
import { newsletterModule } from './Newsletter/ui'
import { productApplicationSliderModule } from './ProductApplicationSlider/ui'
import { productHeaderModule } from './ProductHeader/ui'
import { productSpecificationModule } from './ProductSpecification/ui'
import { productReviewsModule } from './ProductReviews/ui'
import { productsSetModule } from './ProductsSet/ui'
import { productsListModule } from './ProductsList/ui'
import { productsTeaserModule } from './ProductsTeaser/ui'
import { productsUpsellModule } from './ProductsUpsell/ui'
import { profileNavModule } from './ProfileNav/ui'
import { reviewsTeaserModule } from './ReviewsTeaser/ui'
import { tabsModule } from './Tabs/ui'
import { textModule } from './Text/ui'
import { usageCalculatorModule } from './UsageCalculator/ui'
import { videoModule } from './Video/ui'
import { webinarsListModule } from './WebinarsList/ui'
import { selenaFormModule } from './SelenaForm/ui'
import { videoTeaserModule } from './VideoTeaser/ui'
import { iframeModule } from './Iframe/ui'

export type { ContainerData as ContainerModule } from './Container/ui'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const containerUiComponent = ContainerUi

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const modulesUiRegistry: Record<string, ModulesUiRegistryEntry> = {
  [AvailableModuleDriver.Accordion]: accordionModule,
  [AvailableModuleDriver.AdvertiseBox]: advertiseBoxModule,
  [AvailableModuleDriver.ArticlesList]: articlesListModule,
  [AvailableModuleDriver.ArticleHeader]: articleHeaderModule,
  [AvailableModuleDriver.ArticlesTeaser]: articlesTeaserModule,
  [AvailableModuleDriver.ArticlesTeaserBox]: articleTeaserBoxModule,
  [AvailableModuleDriver.ArtisticCarousel]: artisticCarouselModule,
  [AvailableModuleDriver.AttachmentsList]: attachmentsListModule,
  [AvailableModuleDriver.BrandTeaser]: brandTeaserModule,
  [AvailableModuleDriver.Button]: buttonModule,
  [AvailableModuleDriver.Breadcrumbs]: breadcrumbsModule,
  [AvailableModuleDriver.BenefitsBox]: benefitsBoxModule,
  [AvailableModuleDriver.CertificatesList]: certificatesListModule,
  [AvailableModuleDriver.CTABox]: ctaModule,
  [AvailableModuleDriver.ContactForm]: contactFormModule,
  [AvailableModuleDriver.Creations]: creationsModule,
  [AvailableModuleDriver.CustomerSupport]: customerSupportModule,
  [AvailableModuleDriver.DescriptionList]: descriptionListModule,
  [AvailableModuleDriver.FloatingOrderRenewal]: floatingOrderRenewalModule,
  [AvailableModuleDriver.Footer]: footerModule,
  [AvailableModuleDriver.Heading]: headingModule,
  [AvailableModuleDriver.Hero]: heroModule,
  [AvailableModuleDriver.Iframe]: iframeModule,
  [AvailableModuleDriver.Image]: imageModule,
  [AvailableModuleDriver.ImageList]: imageListModule,
  [AvailableModuleDriver.Navbar]: navbarModule,
  [AvailableModuleDriver.NavigationCTABox]: navigationCTABoxModule,
  [AvailableModuleDriver.Newsletter]: newsletterModule,
  [AvailableModuleDriver.ProductApplicationSlider]: productApplicationSliderModule,
  [AvailableModuleDriver.ProductHeader]: productHeaderModule,
  [AvailableModuleDriver.ProductReviews]: productReviewsModule,
  [AvailableModuleDriver.ProductsList]: productsListModule,
  [AvailableModuleDriver.ProductSpecification]: productSpecificationModule,
  [AvailableModuleDriver.ProductsSet]: productsSetModule,
  [AvailableModuleDriver.ProductsTeaser]: productsTeaserModule,
  [AvailableModuleDriver.ProductsUpsell]: productsUpsellModule,
  [AvailableModuleDriver.ProfileNav]: profileNavModule,
  [AvailableModuleDriver.ReviewsTeaser]: reviewsTeaserModule,
  [AvailableModuleDriver.Tabs]: tabsModule,
  [AvailableModuleDriver.Text]: textModule,
  [AvailableModuleDriver.SelenaForm]: selenaFormModule,
  [AvailableModuleDriver.UsageCalculator]: usageCalculatorModule,
  [AvailableModuleDriver.Video]: videoModule,
  [AvailableModuleDriver.VideoTeaser]: videoTeaserModule,
  [AvailableModuleDriver.WebinarsList]: webinarsListModule
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function resolveModulesUiRegistry (allowed: string[]): Record<string, ModulesUiRegistryEntry> {
  if (allowed.length === 0) {
    return modulesUiRegistry
  }

  const filteredRegistry: Record<string, ModulesUiRegistryEntry> = {}
  for (const a of allowed) {
    if (!modulesUiRegistry[a]) {
      continue
    }

    filteredRegistry[a] = modulesUiRegistry[a]
  }

  return filteredRegistry
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export async function resolveStructure<S extends HasStructure = HasStructure> (
  structure: S,
  relatedService: IRelatedService
): Promise<S> {
  for (const [id, container] of Object.entries(structure.containers)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    structure.containers[id] = await resolveContainerContent(container, relatedService)
  }

  for (const [id, module] of Object.entries(structure.modules)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolver: ModuleContentResolver<any, any> | undefined = modulesUiRegistry[module.driver]?.resolver
    if (!resolver) {
      delete structure.modules[id]
      continue
    }

    module.content = await resolver(module.content, relatedService)
    structure.modules[id] = module
  }

  return structure
}
